import { PlusIcon } from '@heroicons/react/outline';
import { Empty } from 'antd';
import { useEffect, useRef, useState } from 'react';

import AddressCard from './AddressCard';
import ButtonDefault, { ButtonVariants } from '../shared/basic/button';
import { ShouldRender } from '../shared/basic/ShouldRender';
import CustomLoader from '../shared/Loading';
import { useAddresses } from '../../hooks/useAddresses';
import { Address } from '../../utils/interfaces/Manage-Addresses';

const ManageAddress: React.FC = () => {
  const [selectedAddress, setSelectedAddress] = useState<number | null>(null);
  const hasFetchedAddresses = useRef(false);
  const { getAllAddresses, loading, address } = useAddresses();

  const [addresses, setAddresses] = useState<Address[]>([]);
  const addAddress = () => {
    setAddresses((prevAddresses) => [
      ...prevAddresses,
      {
        id: new Date().getTime(),
        fullname: '',
        email: '',
        postalcode: '',
        billingPostalcode: '',
        billingAddress: '',
        billingCity: '',
        billingCountry: '',
        billingState: '',
        set_default: 0,
        phone: '',
        country: '',
        city: '',
        state: '',
        address: '',
        iso2: '',
        country_code: '',
        edit: { state: true, type: 'Add Address' },
      },
    ]);
  };

  const deleteAddress = (id: number) => {
    setAddresses((prevAddresses) =>
      prevAddresses.filter((address) => address.id !== id),
    );
  };

  useEffect(() => {
    if (!hasFetchedAddresses.current) {
      getAllAddresses();

      hasFetchedAddresses.current = true;
    }
  }, [getAllAddresses, address]);

  useEffect(() => {
    setAddresses(address as Address[]);
  }, [address]);

  return (
    <>
      <div className='container'>
        <ShouldRender check={loading}>
          <div className='flex justify-center py-40'>
            <CustomLoader />
          </div>
        </ShouldRender>
        <ShouldRender check={addresses?.length && !loading}>
          <div className='flex w-full flex-col'>
            {addresses?.map((address, index) => (
              <div key={`${address?.id}-${index}`} className=' w-full'>
                <AddressCard
                  edit={address.edit}
                  selectedAddress={selectedAddress}
                  setSelectedAddress={setSelectedAddress}
                  setEdit={(editState) => {
                    const updatedAddresses = addresses.map((a) =>
                      a.id === address.id ? { ...a, edit: editState } : a,
                    );
                    setAddresses(updatedAddresses);
                  }}
                  formType='Add Address'
                  data={address}
                  onDelete={deleteAddress}
                  setAddresses={setAddresses}
                />
              </div>
            ))}
          </div>
        </ShouldRender>

        <ShouldRender check={!addresses?.length && !loading}>
          <div className='py-20'>
            <Empty
              description={
                <div>
                  <div className='pt-5 flex flex-col gap-y-5'>
                    <span>No Address Found!</span>
                    <span className='flex justify-center'>
                      <ButtonDefault
                        size={1}
                        variant={ButtonVariants.UNSTYLED}
                        onClick={addAddress}
                        className='w-full md:w-min p-1 rounded-md disabled:cursor-not-allowed border border-[#3A3A3A] text-fadedWhite bg-[#151515] hover:bg-[#1d1d1d]  disabled:bg-dropDownMenuBg disabled:text-[#3E3E3E] disabled:border-0'
                      >
                        <span className='flex text-xs gap-x-2 items-center px-2 py-1  whitespace-nowrap'>
                          <PlusIcon className='w-3.5 h-3.5 text-white' /> Add
                          new address
                        </span>
                      </ButtonDefault>
                    </span>
                  </div>
                </div>
              }
            />
          </div>
        </ShouldRender>
        <ShouldRender check={!(!addresses?.length && !loading)}>
          <div className='pt-5'>
            <ButtonDefault
              size={1}
              variant={ButtonVariants.UNSTYLED}
              onClick={addAddress}
              className='w-full md:w-min p-1 rounded-md disabled:cursor-not-allowed border border-[#3A3A3A] text-fadedWhite bg-[#151515] hover:bg-[#1d1d1d]  disabled:bg-dropDownMenuBg disabled:text-[#3E3E3E] disabled:border-0'
            >
              <span className='flex text-xs gap-x-2 items-center px-2 py-1  whitespace-nowrap'>
                <PlusIcon className='w-3.5 h-3.5 text-white' /> Add new address
              </span>
            </ButtonDefault>
          </div>
        </ShouldRender>
      </div>
    </>
  );
};

export default ManageAddress;
